import {Component, OnInit} from '@angular/core';
import {ModalNavigationService} from '../../../../../services/gui/modal/modal-navigation.service';

@Component({
  selector: 'licence-management-auto-assign-modal',
  templateUrl: './auto-assign-modal.component.html',
  styleUrls: ['./auto-assign-modal.component.scss'],
  standalone: false,
})
export class LicenceManagementAutoAssignModalComponent implements OnInit {
  public disabled: boolean;
  public productive: boolean;
  public machineCode: string[];

  constructor(private modalNavigation: ModalNavigationService) {
    this.disabled = false;
    this.productive = true;
    this.machineCode = [];
  }

  ngOnInit(): void {}

  public done(): void {
    this.modalNavigation.result({ disabled: this.disabled, productive: this.productive, machineCode: this.machineCode });
  }

  public onEntriesChanged(entries: string[]): void {
    this.machineCode = entries;
  }
}
